<template lang="pug">
button(:class="classList" @click="goPricing") {{ copy || 'Get a plan' }}
</template>

<script>
export default {
  name: 'getPlan',
  props: {
    classes: String,
    isPersecond: String,
    isBlendeo: String,
    coupon: String,
    copy: String,
    monthly: String,
  },
  data() {
    return {
      classList: this.classes,
    };
  },
  created() {
    if (!this.classes) {
      this.classList = 'btn btn--white';
    }
  },
  methods: {
    goPricing() {
      const searchParams = new URLSearchParams();
      ga('send', 'event', 'Get A Plan', 'Button Click', 'Get A Plan');

      // Populate the query parameters
      if (this.isPersecond) {
        searchParams.set('fps', '1');
      }

      if (this.isBlendeo) {
        searchParams.set('blendeo', '1');
      }

      if (this.coupon) {
        localStorage.setItem('coupon', this.coupon);
        searchParams.set('coupon', this.coupon);
      }

      if (this.monthly) {
        searchParams.set('m', this.monthly);
      }

      // Go to the pricing page
      this.$router.push('/products/pricing/?' + searchParams.toString());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/getPlan.vue